import * as React from "react";
import { Container, ContainerFW } from "../../global";
import { getColors } from "../../../utils/getColors";
import { FeatureCard } from "./FeatureCard/FeatureCard";
import { getContainerClassPerMaxWidth } from "../../../utils";
export const FeatureCardsSection = ({ backgroundColor, cards, styleVariant = "default", containerMaxWidth = "1128px" }) => {
    const { bgColor } = getColors(backgroundColor);
    const extraClassName = styleVariant === "default" ? "feature-cards-section--default" : "feature-cards-section--title-dominates-card";
    const containerMaxWidthClass = containerMaxWidth && getContainerClassPerMaxWidth(containerMaxWidth);
    return (React.createElement("div", { className: `feature-cards-section ${extraClassName}`, style: { backgroundColor: bgColor } },
        React.createElement(ContainerFW, { className: containerMaxWidthClass },
            React.createElement(Container, { className: containerMaxWidthClass },
                React.createElement("div", { className: "feature-cards-section__cards-container" }, cards.map((card, index) => React.createElement(FeatureCard, { key: index, ...card, cardClass: `item${index}` })))))));
};
